var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var delimiters_1 = require("./delimiters");
var valueNode_1 = require("./valueNode");
var subComponent_1 = require("./subComponent");
var Component = (function (_super) {
    __extends(Component, _super);
    function Component(parent, key, text) {
        _super.call(this, parent, key, text, delimiters_1.default.SubComponent);
    }
    Component.prototype.read = function (path) {
        return this.children[parseInt(path.shift()) - 1];
    };
    Component.prototype.writeCore = function (path, value) {
        return this.writeAtIndex(path, value, parseInt(path.shift()) - 1);
    };
    Component.prototype.createChild = function (text, index) {
        return new subComponent_1.default(this, (index + 1).toString(), text);
    };
    return Component;
})(valueNode_1.default);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Component;
